import { StaffBadge } from '@/components/ui/StaffBadge';
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';
import * as React from 'react';
import { View } from 'react-native';

export function UsernameBadge({
  username,
  isStaff = false,
  prefix = '@',
  className,
  textClassName,
}: {
  username: string;
  isStaff?: boolean;
  prefix?: string;
  className?: string;
  textClassName?: string;
}) {
  return (
    <View className={cn('flex-row items-center gap-1.5 self-start', className)}>
      <Text variant="small" className={cn('leading-4', textClassName)} numberOfLines={1}>
        {prefix}
        {username}
      </Text>
      {isStaff ? <StaffBadge className="size-3.5" /> : null}
    </View>
  );
}
